<template>
  <div class="element-box">
    <form @submit.prevent="onSearch">
      <div class="row">
        <div class="col-lg-2 col-md-6 col-sm-12">
          <div v-if="yearsDropdown && yearsDropdown.length">
            <SelectVue
                v-model="filters.year"
                :options="yearsDropdown"
                :is-clear="true"
                :placeholder="$t('general.year')" />
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div v-if="monthsInYearDropdown && monthsInYearDropdown.length">
            <SelectVue
                v-model="filters.month"
                :options="monthsInYearDropdown"
                :is-clear="true"
                :placeholder="$t('general.month')" />
          </div>
        </div>
        <div class="col-lg-2 col-md-12 col-sm-12 col-12">
          <SearchButton
              type="submit"
              :label="$t('general.button.search')"
              :loading="loading"/>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup>
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs } from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  yearsDropdown: {
    type: Array,
    require: true,
  },
  monthsInYearDropdown: {
    type: Array,
    require: true,
  },
  filters: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit        = defineEmits([ 'search' ]);
const { filters } = toRefs(props);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}
</script>

<style scoped></style>
